export const requestsSlr = (state) => state.requestsReducer.requestsState;
export const fetchRequestsSummarySlr = (state) => state.requestsReducer.fetchRequestsSummary;